import Vue from 'vue'
import VueI18n from 'vue-i18n'
import nl from './locale/nl.json'
import en from './locale/en.json'
import store from '../vuex'

Vue.use(VueI18n)

const messages = {
  nl: nl,
  en: en
}

var defaultLocale = 'nl'
var supportedLocales = Object.keys(messages)

var locale = defaultLocale
if (navigator.language || navigator.userLanguage) {
  var language = (navigator.language || navigator.userLanguage).substring(0, 2)
  if (supportedLocales.includes(language)) {
    locale = language
  }
}

const i18n = new VueI18n({
  locale: store.state.language ? store.state.language : locale,
  fallbackLocale: defaultLocale,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js